import { html } from "../../sharedScripts/syntaxHighlighters.js";

// Query all placeholder elements with data-decoration attribute
const decorationPlaceholders =
  document.querySelectorAll<HTMLElement>("[data-decoration]");

decorationPlaceholders.forEach((placeholder) => {
  const decorationType = placeholder.getAttribute("data-decoration");
  const className = placeholder.getAttribute("data-class") || "";

  let svgHTML = "";

  if (decorationType === "star") {
    svgHTML = html`<svg
      class="${className}"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 39 50"
    >
      <path
        d="M19.139,0C19.139,0 21.62,13.34 24.81,17.48C28,21.62 38.278,24.84 38.278,24.84C38.278,24.84 28,28.061 24.81,32.201C21.62,36.341 19.139,49.681 19.139,49.681C19.139,49.681 16.658,36.341 13.468,32.201C10.278,28.061 0,24.84 0,24.84C0,24.84 10.278,21.62 13.468,17.48C16.658,13.34 19.139,0 19.139,0Z"
      />
    </svg>`;
  } else if (decorationType === "wiggly") {
    svgHTML = html`<svg
      ${className ? `class="${className}"` : ""}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 181 156"
      style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;"
    >
      <path
        class="wiggly-path"
        d="M6.25,74.302C6.25,74.302 106.855,-7.558 117.961,8.285C127.528,21.933 71.781,88.743 83.963,107.896C91.425,119.628 170.708,48.333 173.635,64.897C179.469,97.911 137.891,126.263 170.296,148.841"
        style="fill:none;stroke:rgb(239,188,76);stroke-width:12.5px;"
      />
    </svg>`;
  } else if (decorationType === "wiggly2") {
    svgHTML = html`<svg
      ${className ? `class="${className}"` : ""}
      viewBox="0 0 190 203"
      xmlns="http://www.w3.org/2000/svg"
      style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;"
    >
      <path
        class="wiggly-path2"
        d="M184.239,196.898C184.239,196.898 157.525,201.095 145.065,182.76C125.24,153.587 140.43,111.128 130.082,91.451C120.286,72.824 93.58,101.612 79.468,81.079C61.331,54.689 84.509,21.227 75.889,8.685C65.012,-7.142 6.008,35.821 5.208,42.456"
        style="fill:none;stroke:rgb(239,188,76);stroke-width:10.42px;"
      />
    </svg>`;
  } else if (decorationType === "flag") {
    svgHTML = html`<svg
      ${className ? `class="${className}"` : ""}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 81 110"
    >
      <path
        d="M79.528,0.5L79.478,108.5L39.978,76.301L0.5,108.5L0.5,0.5L79.528,0.5Z"
        style="fill:rgb(239,188,76);stroke:black;stroke-width:1px;"
        vector-effect="non-scaling-stroke"
      />
    </svg>`;
  }

  if (svgHTML) {
    placeholder.innerHTML = svgHTML;
  }
});
